/**
 * A/B Test — Vacuum Kit pack rewards cards
 * Product: /products/vacuum-kit only
 *
 * Toggle: body[data-vacuum-pack-rewards-ab="true|false"] (Intelligems owns this)
 *   - false: native 1 / 2 / 4 / 6 pack rows
 *   - true:  tall pack cards with gift lines + locked exclusive rewards
 *            1 Pack → Free Air Pump
 *            2 Pack → Free Air Pump + Free Shipping
 *            4 Pack → Air Pump + Shipping + Luggage Tag + Lifetime Warranty
 *            6 Pack hidden
 * Gift cards under the packs (pack rows are unchanged, luggage tag stays there):
 *   Free Air Pump on every pack, crossed $69
 *   Free Shipping unlocks on 2 Pack
 *   Lifetime Warranty unlocks on 4 Pack
 * Dev preview: ?vacuum_pack_rewards_test=b
 */
(function () {
  'use strict';

  if (window.__vacuumPackRewardsAbInit) return;
  window.__vacuumPackRewardsAbInit = true;

  var ATTR = 'data-vacuum-pack-rewards-ab';
  var ACTIVE_CLASS = 'vacuum-pack-rewards-ab--active';
  var PACK_CLASS = 'vpr-pack-option';
  var PERKS_ATTR = 'data-vpr-perks';
  var EXCLUSIVE_ATTR = 'data-vpr-exclusives';

  var PUMP_ICON = 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame65.png?v=1741943675';
  var SHIP_ICON = 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/Frame_2.png?v=1780054692';
  var TAG_ICON = 'https://cdn.shopify.com/s/files/1/0924/3502/2169/files/image_363.png?v=1779712168';

  var LOCK_SVG =
    '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false">' +
    '<rect x="5" y="11" width="14" height="9" rx="2" fill="none" stroke="#222" stroke-width="1.6"/>' +
    '<path d="M8 11V8.2a4 4 0 0 1 8 0V11" fill="none" stroke="#222" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>';

  var SHIELD_SVG =
    '<svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M7.5 0.475098L14.25 2.73135V9.12406C14.25 13.6366 11.25 16.6449 7.5 18.5251C3.75 16.6449 0.75 13.6366 0.75 9.12406V2.73135L7.5 0.475098Z" fill="#EC652D"/>' +
    '<path d="M7.5 1.979L12.9375 3.85921V9.1238C12.9375 12.8842 10.5 15.5165 7.5 17.0207C4.5 15.5165 2.0625 12.8842 2.0625 9.1238V3.85921L7.5 1.979Z" stroke="#F6A37F" stroke-width="0.95"/>' +
    '<path d="M9.94513 6.9258C10.2237 6.61858 10.698 6.59589 11.0044 6.87516C11.3109 7.15457 11.3336 7.63046 11.0549 7.9378L7.30495 12.0743C7.16701 12.2264 6.97292 12.3153 6.76796 12.3202C6.56299 12.3251 6.36482 12.2456 6.21981 12.1002L4.15707 10.0318C3.8643 9.7381 3.86432 9.26205 4.15707 8.96836C4.44997 8.67466 4.92504 8.67466 5.21793 8.96836L6.72402 10.4786L9.94513 6.9258Z" fill="white"/>' +
    '</svg>';

  var PERKS = {
    '1': [{ key: 'pump', text: '+ Free Air Pump' }],
    '2': [
      { key: 'pump', text: '+ Free Air Pump' },
      { key: 'shipping', text: '+ Free Shipping' }
    ],
    '4': [
      { key: 'pump', text: '+ Free Air Pump' },
      { key: 'shipping', text: '+ Free Shipping' },
      { key: 'luggage', text: '+ Free Luggage Tag ($49 Value)' },
      { key: 'warranty', text: '+ Free Lifetime Warranty' }
    ]
  };

  /* Gift cards under the packs only. Pack rows above stay as they are, including the luggage tag. */
  var EXCLUSIVES = [
    { pack: '', unlock: 1, key: 'pump', banner: 'FREE', price: '$69', label: 'Free Air Pump' },
    { pack: '2 Pack', unlock: 2, key: 'shipping', banner: 'FREE', price: '', label: 'Free Shipping' },
    { pack: '4 Pack', unlock: 4, key: 'warranty', banner: 'FREE', price: '', label: 'Lifetime Warranty' }
  ];

  var applying = false;
  var lastEnabled = null;
  var timer = null;
  var booted = false;
  var perkNodes = {};
  var exclusivesNode = null;

  function isDevVariantB() {
    try {
      var v = new URLSearchParams(window.location.search).get('vacuum_pack_rewards_test');
      return v === 'b' || v === 'true' || v === '1';
    } catch (e) {
      return false;
    }
  }

  function isTruthy(value) {
    var n = String(value || '').trim().toLowerCase();
    return n === 'true' || n === '1' || n === 'on' || n === 'yes';
  }

  function isAbEnabled() {
    if (isDevVariantB()) return true;
    if (!document.body) return false;
    return isTruthy(document.body.getAttribute(ATTR)) || isTruthy(document.documentElement.getAttribute(ATTR));
  }

  function isVacuumKitPdp() {
    if (document.querySelector('product-gallery[data-gallery-vacuum-kit-pdp="true"]')) return true;
    var path = String(location.pathname || '').toLowerCase();
    return path.indexOf('vacuum-kit') > -1 ||
      path.indexOf('aerless-vacuum-kit') > -1 ||
      path.indexOf('aerless%E2%84%A2-vacuum-kit') > -1;
  }

  function giftImage(key) {
    var script = document.querySelector('script[src*="vacuum-pack-rewards-ab"]');
    if (!script) return '';
    return script.getAttribute('data-gift-' + key) || '';
  }

  function iconHtml(key) {
    if (key === 'pump') return '<img src="' + PUMP_ICON + '" alt="" width="22" height="22" loading="lazy" decoding="async">';
    if (key === 'shipping') return '<img src="' + SHIP_ICON + '" alt="" width="22" height="22" loading="lazy" decoding="async">';
    if (key === 'luggage') return '<img src="' + TAG_ICON + '" alt="" width="22" height="22" loading="lazy" decoding="async">';
    return SHIELD_SVG;
  }

  function packKeyFromLabel(label) {
    if (!label || !label.classList) return null;
    if (label.classList.contains('block-swatch--pack-6')) return '6';
    if (label.classList.contains('block-swatch--pack-4')) return '4';
    if (label.classList.contains('block-swatch--pack-2')) return '2';
    if (label.classList.contains('block-swatch--pack-1')) return '1';
    var text = String(label.textContent || '').replace(/\s+/g, ' ').toLowerCase();
    if (/\b6\s*pack\b/.test(text)) return '6';
    if (/\b4\s*pack\b/.test(text)) return '4';
    if (/\b2\s*pack\b/.test(text)) return '2';
    if (/\b1\s*pack\b/.test(text)) return '1';
    return null;
  }

  function getPackValues() {
    var label = document.querySelector(
      '.block-swatch--pack-1, .block-swatch--pack-2, .block-swatch--pack-4'
    );
    if (!label) return null;
    return label.closest('.variant-picker__option-values');
  }

  function selectedPackNumber() {
    var values = getPackValues();
    var checked = values ? values.querySelector('input:checked') : null;
    var label = checked ? checked.nextElementSibling : null;
    var key = packKeyFromLabel(label);
    var n = parseInt(key, 10);
    return isNaN(n) ? 1 : n;
  }

  function buildPerks(key) {
    var items = PERKS[key];
    if (!items) return null;
    var wrap = document.createElement('div');
    wrap.className = 'vpr-perks';
    wrap.setAttribute(PERKS_ATTR, 'true');
    var html = '';
    var i;
    for (i = 0; i < items.length; i++) {
      html +=
        '<div class="vpr-perk vpr-perk--' + items[i].key + '">' +
          '<span class="vpr-perk__icon">' + iconHtml(items[i].key) + '</span>' +
          '<span class="vpr-perk__text">' + items[i].text + '</span>' +
        '</div>';
    }
    wrap.innerHTML = html;
    return wrap;
  }

  function buildExclusives() {
    var wrap = document.createElement('div');
    wrap.className = 'vpr-exclusives';
    wrap.setAttribute(EXCLUSIVE_ATTR, 'true');
    var html = '';
    var i;
    for (i = 0; i < EXCLUSIVES.length; i++) {
      var priceHtml = EXCLUSIVES[i].price
        ? ' <span class="vpr-exclusive__price">' + EXCLUSIVES[i].price + '</span>'
        : '';
      var packHtml = EXCLUSIVES[i].pack
        ? '<div class="vpr-exclusive__pack">' + EXCLUSIVES[i].pack + '</div>'
        : '';
      html +=
        '<div class="vpr-exclusive" data-unlock="' + EXCLUSIVES[i].unlock + '">' +
          '<div class="vpr-exclusive__card">' +
            '<div class="vpr-exclusive__locked">' +
              packHtml +
              '<div class="vpr-exclusive__lock">' + LOCK_SVG + '</div>' +
              '<div class="vpr-exclusive__badge">Exclusive</div>' +
            '</div>' +
            '<div class="vpr-exclusive__unlocked">' +
              '<div class="vpr-exclusive__banner">' + EXCLUSIVES[i].banner + priceHtml + '</div>' +
              '<div class="vpr-exclusive__art">' +
                '<img src="' + giftImage(EXCLUSIVES[i].key) + '" alt="" decoding="sync">' +
              '</div>' +
              '<div class="vpr-exclusive__label">' + EXCLUSIVES[i].label + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }
    wrap.innerHTML = html;
    return wrap;
  }

  function syncExclusives() {
    var pack = selectedPackNumber();
    document.querySelectorAll('.vpr-exclusive').forEach(function (card) {
      var need = parseInt(card.getAttribute('data-unlock'), 10);
      card.classList.toggle('is-unlocked', pack >= need);
    });
  }

  function detachNode(node) {
    if (node && node.parentNode) node.parentNode.removeChild(node);
  }

  function perkNode(key) {
    if (!PERKS[key]) return null;
    if (!perkNodes[key]) perkNodes[key] = buildPerks(key);
    return perkNodes[key];
  }

  function exclusivesEl() {
    if (!exclusivesNode) exclusivesNode = buildExclusives();
    return exclusivesNode;
  }

  function removeVariant() {
    detachNode(exclusivesNode);
    var key;
    for (key in perkNodes) {
      if (Object.prototype.hasOwnProperty.call(perkNodes, key)) detachNode(perkNodes[key]);
    }
    document.querySelectorAll('[' + PERKS_ATTR + '], [' + EXCLUSIVE_ATTR + ']').forEach(function (el) {
      if (el !== exclusivesNode && el.parentNode) el.parentNode.removeChild(el);
    });
    document.querySelectorAll('.' + PACK_CLASS).forEach(function (el) {
      el.classList.remove(PACK_CLASS);
    });
    if (document.body) document.body.classList.remove(ACTIVE_CLASS);
  }

  function clearForeignGifts(label) {
    label.querySelectorAll('.bundle-perks, .kaching-bundles__bar-subtitles, .kaching-bundles__bar-subtitle-list').forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function applyVariant() {
    if (!document.body) return;
    document.body.classList.add(ACTIVE_CLASS);

    var values = getPackValues();
    if (!values) return;

    values.classList.add(PACK_CLASS);

    values.querySelectorAll('.block-swatch').forEach(function (label) {
      clearForeignGifts(label);
      var key = packKeyFromLabel(label);
      var perks = perkNode(key);
      label.querySelectorAll('[' + PERKS_ATTR + ']').forEach(function (el) {
        if (el !== perks && el.parentNode) el.parentNode.removeChild(el);
      });
      if (perks && perks.parentNode !== label) label.appendChild(perks);
    });

    var fieldset = values.closest('.variant-picker__option') || values.parentNode;
    var gifts = exclusivesEl();
    if (fieldset && gifts.parentNode !== fieldset) fieldset.appendChild(gifts);

    syncExclusives();
  }

  function isBuilt() {
    var values = getPackValues();
    return !!(
      values &&
      values.classList.contains(PACK_CLASS) &&
      values.querySelector('[' + PERKS_ATTR + ']') &&
      document.querySelector('[' + EXCLUSIVE_ATTR + ']')
    );
  }

  function dedupeGifts() {
    var values = getPackValues();
    if (!values) return;
    values.querySelectorAll('.block-swatch').forEach(function (label) {
      clearForeignGifts(label);
      var lists = label.querySelectorAll(':scope > [' + PERKS_ATTR + ']');
      var i;
      for (i = 1; i < lists.length; i++) {
        if (lists[i].parentNode) lists[i].parentNode.removeChild(lists[i]);
      }
    });
  }

  function run() {
    if (applying) return;
    applying = true;
    try {
      var enabled = isAbEnabled() && isVacuumKitPdp();
      if (!enabled) {
        if (lastEnabled !== false) removeVariant();
        lastEnabled = false;
        return;
      }
      if (!isBuilt()) applyVariant();
      dedupeGifts();
      syncExclusives();
      lastEnabled = true;
    } finally {
      applying = false;
    }
  }

  function scheduleRun() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(run, 40);
  }

  function findVariantPickerBlock(root, blockId) {
    if (!root || !root.querySelectorAll) return null;
    var nodes = root.querySelectorAll('[data-block-type="variant-picker"]');
    var i;
    for (i = 0; i < nodes.length; i++) {
      if (!blockId || nodes[i].getAttribute('data-block-id') === blockId) {
        if (nodes[i].querySelector('.block-swatch--pack-1, .block-swatch--pack-2, .block-swatch--pack-4, .vpr-pack-option')) {
          return nodes[i];
        }
      }
    }
    return null;
  }

  function inputByValue(root, name, value) {
    var inputs = root.querySelectorAll('input[data-option-position]');
    var i;
    for (i = 0; i < inputs.length; i++) {
      if (inputs[i].name === name && inputs[i].value === value) return inputs[i];
    }
    return null;
  }

  function copyText(from, to, selector) {
    if (!from || !to) return;
    var next = from.querySelector(selector);
    var live = to.querySelector(selector);
    if (!next || !live) return;
    if (live.textContent !== next.textContent) live.textContent = next.textContent;
  }

  function syncImg(liveImg, nextImg) {
    if (!liveImg || !nextImg) return;
    var src = nextImg.getAttribute('src') || nextImg.getAttribute('data-src') || '';
    var srcset = nextImg.getAttribute('srcset') || nextImg.getAttribute('data-srcset') || '';
    if (src && liveImg.getAttribute('src') !== src) liveImg.setAttribute('src', src);
    if (srcset) liveImg.setAttribute('srcset', srcset);
    else liveImg.removeAttribute('srcset');
    if (liveImg.hasAttribute('data-src')) liveImg.setAttribute('data-src', src);
    if (liveImg.hasAttribute('data-srcset')) {
      if (srcset) liveImg.setAttribute('data-srcset', srcset);
      else liveImg.removeAttribute('data-srcset');
    }
  }

  function syncSwatch(liveLabel, nextLabel) {
    if (!liveLabel || !nextLabel) return;
    copyText(nextLabel, liveLabel, '.price');
    copyText(nextLabel, liveLabel, '.compare-price');
    copyText(nextLabel, liveLabel, '.discount-percentage');
    copyText(nextLabel, liveLabel, '.igSavingsPercentage');
    copyText(nextLabel, liveLabel, '.most-popular');
    var liveImg = liveLabel.querySelector('.main-wrap-image img') || liveLabel.querySelector('.swatch-wrap img');
    var nextImg = nextLabel.querySelector('.main-wrap-image img') || nextLabel.querySelector('.swatch-wrap img');
    syncImg(liveImg, nextImg);
    liveLabel.classList.toggle('is-disabled', nextLabel.classList.contains('is-disabled'));
  }

  /* Impact replaceWith on the variant picker unmounts the pack cards and gifts.
     Keep that block, and copy prices + pack images from the new HTML onto the live cards.
     NOTE: product:rerender does NOT bubble — restore must be deferred after target listeners. */
  function preservePickerOnRerender(event) {
    if (!isAbEnabled() || !isVacuumKitPdp()) return;
    var fragment = event.detail && event.detail.htmlFragment;
    if (!fragment) return;

    /* Also match a leftover "kept" block if a prior restore never ran. */
    var lives = document.querySelectorAll(
      '[data-block-type="variant-picker"], [data-block-type="variant-picker-kept"]'
    );
    lives.forEach(function (live) {
      if (!live.querySelector('.block-swatch--pack-1, .block-swatch--pack-2, .block-swatch--pack-4, .vpr-pack-option')) return;
      var incoming = findVariantPickerBlock(fragment, live.getAttribute('data-block-id'));
      if (!incoming) return;

      live.querySelectorAll('.block-swatch').forEach(function (label) {
        var key = packKeyFromLabel(label);
        var nextLabel = key ? incoming.querySelector('.block-swatch--pack-' + key) : null;
        syncSwatch(label, nextLabel);
      });

      incoming.querySelectorAll('input[data-option-position]').forEach(function (nextInput) {
        var liveInput = inputByValue(live, nextInput.name, nextInput.value);
        if (!liveInput) return;
        liveInput.disabled = nextInput.disabled;
        if (nextInput.checked) liveInput.checked = true;
      });

      var liveScript = live.querySelector('script[data-variant]');
      var nextScript = incoming.querySelector('script[data-variant]');
      if (liveScript && nextScript && liveScript.textContent !== nextScript.textContent) {
        liveScript.textContent = nextScript.textContent;
      }

      live.setAttribute('data-block-type', 'variant-picker-kept');
    });
  }

  function restorePickerBlockType() {
    document.querySelectorAll('[data-block-type="variant-picker-kept"]').forEach(function (el) {
      el.setAttribute('data-block-type', 'variant-picker');
    });
  }

  function afterRerender() {
    restorePickerBlockType();
    if (!isAbEnabled() || !isVacuumKitPdp()) return;
    syncExclusives();
    if (!isBuilt()) scheduleRun();
  }

  function boot() {
    if (booted) return;
    booted = true;
    run();
    [120, 400, 1000, 2000].forEach(function (ms) {
      setTimeout(run, ms);
    });

    document.addEventListener(
      'product:rerender',
      function (event) {
        preservePickerOnRerender(event);
        /* Event does not bubble; ProductRerender runs on the form at target phase.
           Restore on the next tick so "kept" is renamed after Impact skips replaceWith. */
        setTimeout(afterRerender, 0);
      },
      true
    );

    document.addEventListener('change', function (event) {
      if (!event.target || !event.target.closest) return;
      if (!event.target.closest('.vpr-pack-option') && !event.target.closest('variant-picker')) return;
      if (!isAbEnabled() || !isVacuumKitPdp()) return;
      syncExclusives();
      if (!isBuilt()) scheduleRun();
    });

    document.addEventListener('variant:change', function () {
      if (!isAbEnabled() || !isVacuumKitPdp()) return;
      syncExclusives();
      if (!isBuilt()) scheduleRun();
    });

    if (document.body) {
      new MutationObserver(function (mutations) {
        var i;
        for (i = 0; i < mutations.length; i++) {
          if (mutations[i].type === 'attributes' && mutations[i].attributeName === ATTR) {
            lastEnabled = null;
            scheduleRun();
            return;
          }
        }
        if (applying) return;
        if (isAbEnabled() && isVacuumKitPdp() && !isBuilt()) scheduleRun();
      }).observe(document.body, {
        attributes: true,
        attributeFilter: [ATTR],
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
